import { defineSlotRecipe as t } from "@pandacss/dev";
import { anatomy as a } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/dialog/dist/index.mjs";
const e = a.extendWith("header", "body", "footer"), n = t({
  className: "drawer",
  slots: [...e.keys()],
  base: {},
  defaultVariants: {
    variant: "right"
  },
  variants: {
    variant: {
      left: {
        positioner: {
          left: 0
        },
        content: {
          _open: {
            animation: "drawer-in-left"
          },
          _closed: {
            animation: "drawer-out-left"
          }
        }
      },
      right: {
        positioner: {
          right: 0
        },
        content: {
          _open: {
            animation: "drawer-in-right"
          },
          _closed: {
            animation: "drawer-out-right"
          }
        }
      }
    }
  }
});
export {
  n as drawer
};
